<template>
    <Teleport v-if="isMounted" to="#teleport-target">
        <div :class="['ap-form-dialog', cssClass]">
            <div class="ap-dialog-form-header">
                <slot name="form-header" />
                <button class="ap-dialog__close" @click="closePopup" :title="$t('common.dialogPopup.close')" />
            </div>
            <div v-if="!showLoader" class="ap-dialog-content">
                <slot name="form-content" />
                <success-message v-if="alertSuccessMessage" type="success" v-html-safe="alertSuccessMessage" />
                <error-message v-if="alertErrorMessage" type="error" v-html-safe="alertErrorMessage" />
            </div>
            <div class="ap-dialog-buttonpane">
                <div class="buttonset">
                    <slot name="form-buttons" />
                </div>
            </div>
            <ap-loader :show="showLoader" theme="blue" />
        </div>
        <div class="ap-dialog-overlay" @click="closePopup"></div>
    </Teleport>
</template>

<script>
    import { ApLoader } from '@ap/ap-plugin-loader'
    import ErrorMessage from 'common/AlertMessage.vue'
    import SuccessMessage from 'common/AlertMessage.vue'
    export default {
        components: {
            ApLoader,
            ErrorMessage,
            SuccessMessage
        },
        data: function () {
            return {
                isMounted: false
            }
        },
        props: {
            cssClass: { type: [String, Array] },
            showLoader: { type: Boolean, default: false },
            alertErrorMessage: { type: String, default: null },
            alertSuccessMessage: { type: String, default: null },
            lock: { type: Boolean, default: false }
        },
        emits: ['close'],
        methods: {
            closePopup() {
                if (!this.lock)
                    this.$emit('close')
            }
        },
        mounted() {
            this.isMounted = true
        }
    }
</script>

<style lang="scss">
    @import '~styles/base';
    @import '~styles/colors';

    .ap-tooltip.vue-tooltip {
        z-index: 30001 !important;
    }

    .ap-dialog-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: none;
        background-color: $dialog-overlay-color;
        opacity: .65;
        z-index: 99
    }

    .ap-form-dialog {
        z-index: 100;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        border: 1px solid #aaa;
        min-width: 500px;
        max-width: 1200px;

        .ap-dialog__close {
            width: 36px;
            height: 36px;
            border: none;
            background: url('~icons/close.svg') no-repeat;
            background-size: 36px auto;
            background-position: center center;
            cursor: pointer;
            margin-left: auto;

            &:hover {
                background-image: url('~icons/close-hover.svg');
            }
        }

        .ap-dialog-form-header {
            padding: 0px;
            font-size: 24px;
            font-weight: bold;
            font-family: $main-font;
            text-transform: uppercase;
            color: $main-font-color;
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            margin: 40px 40px 5px;

            > p {
                margin: 0;
            }
        }

        .ap-dialog-content {
            text-align: left;
            padding: 0px;
            font-size: 14px;
            overflow: auto;
            margin: 0px 40px;


            h1 {
                margin: 0px 0px 10px 0px;
                font-weight: 300;
                white-space: nowrap;
                font-size: 20px;
                padding: 0px 0px;
                overflow-x: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                -ms-text-overflow: ellipsis;
            }

            h2 {
                font-size: 14px;
                line-height: 22px;
                color: #8796A1;
                text-transform: uppercase;
                margin: 7px 0;
            }

            h3 {
                @include main-font-opacity(0.7);
                text-transform: uppercase;
                font-weight: bold;
                font-size: 12px;
                line-height: 26px;
                margin: 0;

                &.required:after {
                    color: $required-item-color;
                    content: " *";
                    top: -3px;
                    position: relative;
                }
            }

            > div {
                margin: 10px 0px 0px 0px;

                strong {
                    font-size: 14px;
                    font-weight: bold;
                }

                em {
                    font-style: normal;
                    font-size: 14px;
                    margin: 0px 0px 0px 5px;
                }
            }
        }

        .ap-dialog-buttonpane {
            padding: 0px;
            margin: 20px 40px 40px;

            .buttonset {
                display: flex;
                flex-direction: row;
                flex: 0 1 auto;
                justify-content: space-between;

                button {
                    padding: 0 30px;
                    width: auto;
                    height: 36px;
                    line-height: 36px;
                    
                    &:only-of-type {
                        margin:auto;
                    }
                }
            }
        }

        &:has(.ap-dialog-buttonpane .buttonset button){ .ap-dialog__close{visibility: hidden;}}
    }
</style>